// Regra única de escalonamento de prioridade por quantidade de cartas.
// Os limites default espelham a config seed de precificação (products/pricing)
// e servem de fallback para telas que ainda não carregam a config em runtime.
export const DEFAULT_PRIORITY_LIMITS = [
    { value: "none", max: 84 },
    { value: "low", max: 126 },
    { value: "mid", max: 252 },
    { value: "high", max: 504 },
    { value: "max", max: 1200 },
];

export const escalatePriorityForQuantity = (numberOfCards, currentPriority, limits = DEFAULT_PRIORITY_LIMITS) => {
    const quantity = Number(numberOfCards) || 0;
    const currentIndex = limits.findIndex((limit) => limit.value === currentPriority);
    const candidates = limits.filter((_, index) => index >= currentIndex);
    const allowed = candidates.find((limit) => quantity <= limit.max);
    if (!allowed) {
        return { priority: "", blocked: true };
    }
    return { priority: allowed.value, blocked: false };
};
